import { combineValidators, composeValidators, isRequired } from "revalidate";
import { CREDIT_CARDS_TYPES } from "app/constants";
import { creditCardValidator } from "app/utils/form/fieldValidators";
import validationMessages from "app/utils/form/validationMessages.js";
import { isAmount, isCreditCardValid, isLessThan } from "app/utils/form/validators";

export const fields = [
	"payment.card.amount",
	"payment.card.holderName",
	"payment.card.number",
	"payment.card.expiryMonth",
	"payment.card.expiryYear",
	"payment.card.cvc",
	"payment.card.encrypted",
];

export const dependantPaymentCardFields = ["expiryMonth", "expiryYear", "cvc", "number"];

export const buildValidator = amountToPay => {
	return combineValidators({
		payment: {
			card: {
				amount: composeValidators(
					isRequired({
						message: validationMessages.creditcardAmountRequired,
					}),
					isAmount({
						message: validationMessages.creditcardAmountFormat,
					}),
					isLessThan(amountToPay)({
						message: validationMessages.creditcardAmountLessThan,
					})
				)("amount"),
				holderName: isRequired({
					message: validationMessages.creditcardHolderNameRequired,
				}),
				expiryMonth: composeValidators(
					isRequired({
						message: validationMessages.creditcardExpiryMonthRequired,
					}),
					isCreditCardValid({ isOnNumberChange: false })({
						message: validationMessages.creditCardInvalid,
					})
				)("expiryMonth"),
				expiryYear: composeValidators(
					isRequired({
						message: validationMessages.creditcardExpiryYearRequired,
					}),
					isCreditCardValid({ isOnNumberChange: false })({
						message: validationMessages.creditCardInvalid,
					})
				)("expiryYear"),
				cvc: composeValidators(
					isRequired({
						message: validationMessages.creditcardCvcRequired,
					}),
					isCreditCardValid({ isOnNumberChange: false })({
						message: validationMessages.creditCardInvalid,
					})
				)("cvc"),
				number: creditCardValidator([
					CREDIT_CARDS_TYPES.VISA,
					CREDIT_CARDS_TYPES.MASTERCARD,
					CREDIT_CARDS_TYPES.AMEX,
				]),
			},
		},
	});
};
